import React from "react";
import { BrowserRouter as Router, Route, Routes, useParams } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Dashboard from "./pages/addDc";
import { SideBar } from "./components/SideBar/sidebar";
import Control from "./pages/control";
import AddDc from "./pages/addDc";
import Room from "./pages/room";
import Technical from "./pages/technical";
import AddRoom from "./pages/addRack";
import Client from "./pages/client";
import Details from "./pages/details";
import SelectRoom from "./pages/selectRooms";
import Charts from "./pages/charts";
import TableRacks from "./pages/tableRacks";
import DataHall from "./pages/dataHall2D";
import Menage from "./pages/AccessMenage";
import axiosInstance from "./auth/axiosInstance";
import Unauthorized from "./pages/unauthorized";
import { StateProvider } from "./store/StateProvider";
import SelectDcs from "./pages/selectDcs";
import LogsPage from "./pages/logs";
import { NavigateWayProvider } from './store/NavigateWayContext';

function App() {

  const { instance, accounts } = useMsal();
  const [user, setUser] = React.useState(undefined)
  function Login() {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });

  }

  React.useEffect(() => {
    if (accounts) {
      axiosInstance(`access-control/${accounts[0]?.username}`)
        .then((res) => {
          if (res.data) {
            setUser(res.data)
          }
        })
        .catch((err) => console.log(err));
    }
  }, [accounts]);

  const url = window.location.href.split('/')

  React.useEffect(() => {
    //  VERIFICA SE A PÁGINA FOI RECARREGADA E REDIRECIONA PARA A HOME
    if (performance.navigation.type === 1) {
      const dominio = window.location.origin;
      window.location.href = dominio;
    }
  }, []);

  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <NavigateWayProvider>
          <StateProvider user={user}>
            {
              !user ? <></> : <SideBar type={user.Type} />
            }
            {
              !!user ?
                <Routes>
                  <Route path="/" element={<Dashboard type={user.Type} />} />
                  {user.Type !== 'View Only' && <Route path="/control" element={<Control />} />}
                  {/* < Route path="/charts" element={<Charts />} /> */}
                  <Route path="/SelectRoom" element={<SelectRoom />} />
                  <Route path="/details/:roomid/:roomName/:date" element={<Details type={user.Type} />} />
                  <Route path="/client" element={<Client type={user.Type} />} />
                  {/* <Route path="/dc" element={<AddDc type={user.Type} />} /> */}
                  <Route path="/logs" element={<LogsPage type={user.Type} />} />
                  <Route path="/room/:dc/:id" element={<Room type={user.Type} />} />
                  <Route path="/datahall" element={<DataHall type={user.Type} />} />
                  {user.Type !== 'View Only' && <Route path="/menage" element={<Menage />} />}
                  <Route path="/site/:dc/:id" element={<Technical />} />
                  <Route path="/site/:dc/:id/table" element={<TableRacks />} />
                  <Route path="/site/:dc/:id/:idCount" element={<AddRoom />} />
                  <Route path="/select/dc" element={<SelectDcs />} />
                  <Route path={'*'} element={<Unauthorized />} />
                </Routes>
                :
                <Routes>
                  <Route path="/site/:dc/:id" element={<Technical />} />
                  <Route path="/site/:dc/:id/table" element={<TableRacks />} />
                  <Route path="/site/:dc/:id/:idCount" element={<AddRoom />} />
                  <Route path={'*'} element={<Unauthorized />} />
                </Routes>
            }

          </StateProvider>
        </NavigateWayProvider>
      </AuthenticatedTemplate>
    </Router>
  )
}

export default App;
